import React from "react";
import {
  Div,
  Paper,
  //Select,
  TextInput,
  H6,
  Col,
  Row,
  Text,
  Divider,
  Upload,
  Image,
} from "qdm-component-library";
import "./style.css";
import { withAllContexts } from "../../../HOCs";
import { withStyles } from "@material-ui/core/styles";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Switch, Avatar, TextField } from "@material-ui/core";
import { uploadImage, getImgUrl, AlertProps } from "../../../utils";
import { Typography } from "@material-ui/core";
import { SelectWithLabel } from "../../../components"
import { DateTimePicker } from "../../common/smartForm/component";
import moment from 'moment';
import CustomInputDatePicker from "../../common/datePicker/inputDatePicker";
class PersonNames extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Showfilter: this.props?.[this.props.saveto]?.names,
      limited: true,
      rows: [{}]
    };
  }

  onChangeState = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value,
    });
  };
  IOSSwitch = withStyles((theme) => ({
    root: {
      width: 37,
      height: 21,
      padding: 0,
      margin: theme.spacing(1),
      marginTop: "-1px",
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(16px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: "#0071F2",
          opacity: 1,
          border: "none",
        },
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
        border: "6px solid #fff",
      },
    },
    thumb: {
      width: 18,
      height: 18,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
  });
  styles = {
    labelStyle: {
      color: "#6F6F6F",
      fontSize: "12px",
      marginBottom: "6px",
      fontFamily: `pc_regular !important`,
    },
    borderStyle: {
      borderRadius: 8,
      borderColor: "#E0E0E0",
    },
    errorBorderStyle: {
      borderRadius: 8,
      border: "1px solid red",
    },
  };

  setData = (name, value, index, limit) => {
    if (limit) {
      if (limit < value.length) {
        return false;
      }
    }
    let patientData = this.props[this.props.saveto];
    patientData.names[index][name] = value;
    if (patientData.names[index].error) {
      patientData.names[index].error[name] = false;
    }
    patientData[this.props.setTo]({
      ...patientData,
    });
  };

  setDetails = (name, value, next, limit) => {
    if (limit) {
      if (limit < value.length) {
        return false;
      }
    }
    let patientData = this.props[this.props.saveto];
    patientData.details[name] = value;
    if (patientData.details?.error) {
      patientData.details.error[name] = false;
    }
    patientData[this.props.setTo]({
      ...patientData,
    });
  };

  newRowAdd = () => {
    this.setState((prevState) => {
      return {
        rows: [...prevState.rows, {}],
      };
    });
  };

  getSize = (size) => {
    let fileSize = size / 1024 / 1024;
    if (fileSize < 1) {
      return `${parseInt(size / 1024) + 1} KB`;
    } else {
      return `${parseInt(fileSize)} MB`;
    }
  };
  handleDelete = (i) => {
    this.props?.person_details?.personDetailList.splice(i, 1);
    this.setState({ ...this.state })

  };

  handleLimit = () => {
    this.setState({
      limited: !this.state.limited,
    });
  };

  FlterOptions = (type) => {
    const { allMasters } = this.props;
    var lista = [];
    const data = allMasters?.[type];
    for (let index in data) {
      var datatemp = {
        value: data[index]?.coding?.display,
      };
      lista.push(datatemp);
    }
    return lista;
  };

  setDataUpload = async (name, value, next, limit) => {
    if (!value.type.includes("image")) {
      this.props.alert.setSnack({
        open: true,
        severity: AlertProps.severity.error,
        msg: "Please Select an Image with size less than 1MB.",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.center,
        tone: true,
      });
      return false;
    }
    var UploadedFiles = [];
    if (limit) {
      if (limit < value.length) {
        return false;
      }
    }
    UploadedFiles = await uploadImage([value]);
    //let patientData = this.props[this.props.saveto];
    // if (UploadedFiles.length > 0) {
    //   patientData.details[name] = {
    //     fileName: UploadedFiles[0].filename,
    //     fileid: UploadedFiles[0].fileid,
    //     filetype: UploadedFiles[0].filetype,
    //     objectid: UploadedFiles[0].objectid,
    //   };
    // }
    let json_to = [{
      fileName: UploadedFiles[0].filename,
      fileid: UploadedFiles[0].fileid,
      filetype: UploadedFiles[0].filetype,
      objectid: UploadedFiles[0].objectid,
    }]
    this.props.handlePersonDetails("upload_image", json_to)

  };
  showfilter = (list, comp_value) => {
    if (list?.length > 0) {
      return list.filter(_ => _._id === comp_value)[0]
    }
    return {};
  }
  render() {
    const {
      //names, 
      details } = [{ name: "", details: "" }];
    const { labelStyle, borderStyle, errorBorderStyle } = this.styles;

    return (
      <Div className="pi-root">
        <Row className={"pn-row-root"}>
          <Col className="pn-image-root">
            <Paper className="pi-paper pn-image-paper-root">
              <Div>
                {this.props?.person_details?.upload_image?.length > 0 ? (
                  <Avatar
                    alt={this.props?.person_details?.upload_image[0]?.fileName}
                    variant={"square"}
                    style={{ width: "100%", height: "100%" }}
                    src={getImgUrl(this.props?.person_details?.upload_image[0]?.fileid)}
                  />
                ) : (
                  <Upload
                    label="Upload Image"
                    className={"pn-image"}
                    labelStyle={{
                      fontSize: 14,
                      letterSpacing: "0px",
                      color: "#6F6F6F !important",
                      backgroundColor: "#00000014 !important",
                      height: "146px",
                      width: "150px",
                      paddingRight: "10px",
                      paddingTop: "63px",
                      textAlign: "center",
                    }}
                    inLineStyles={{ padding: 0, width: "100%" }}
                    showIcon={false}
                    handleChange={(e, value) =>
                      this.setDataUpload("photo", value)
                    }
                  // imgUrl="https://fileupload.dev.ainqaplatform.in/primarycare/10204"
                  />
                )}
              </Div>
              <Div className="pn-upload-actions">
                {/* <Button className="pn-upload-actions-btn" name="Upload Image" /> */}
                <TextInput
                  // handleChange={(e, value) =>
                  //   this.setDetails("image", { url: e, file: value })
                  // }
                  label="Person Id"
                  // onChange={(e) =>
                  //   this.setDetails("practitoner_id", e.target.value, null, 10)
                  // }
                  disabled={true}
                  value={this.props?.person_details?.person_id ?? ""}
                  placeholder="Person Id *"
                  labelStyle={{
                    fontSize: 14,
                    letterSpacing: "0px",
                    color: "#5F84C0 !important",
                    backgroundColor: "#F5FAFF !important",
                  }}
                  style={
                    details?.error?.practitoner_id
                      ? errorBorderStyle
                      : borderStyle
                  }
                  className={"pn-upload-actions-btn"}
                  showIcon={false}
                />
              </Div>
            </Paper>
          </Col>
          <Col className="pn-names-root">
            <Paper className="pi-paper">
              <Div>
                <H6 className="pi-title">
                  {false
                    ? "NEXT OF KIN NAME"
                    : "PERSON DETAILS"}
                </H6>

                <Text onClick={() => this.props.addPersonDetails()} className="pi-addbtn">
                  + Add New
                </Text>

              </Div>
              {/* {JSON.stringify(names.length)} */}
              {this.props?.person_details?.personDetailList
                ?.slice(0, this.state.limited ? this.props?.person_details?.personDetailList.length : 1)
                ?.map((val, i) => (
                  <Row className="pi-actions-root pi-names-root">
                    <Col className="no-padding-left" style={{ padding: "0" }}>
                      {/* <Select
                        value={val?.use?.label ?? null}
                        // helperText={
                        //   val?.error && val?.error["use"] ? "Is required" : ""
                        // }
                        isRequired={true}
                        getOptionLabel="label"
                        options={this?.props?.allMasters?.["use"]}
                        error={val?.error && val?.error["use"] ? true : false}
                        onChangeValue={(e) => this.setData("use", e, i)}
                        label="Use"
                        showArrow
                        placeholder="use"
                        labelStyle={labelStyle}
                        inLineStyles={
                          val?.error?.use ? errorBorderStyle : borderStyle
                        }
                        hoverColor="#0071F2"
                      /> */}
                      {/* <Typography
                        style={{
                          fontSize: "12px",

                          Fontfamily: "pc_regular",
                          color: "#6F6F6F",
                        }}
                        variant="body1"
                      >
                        Use<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <SelectBox
                        list={this?.props?.allMasters?.["use"] ?? []}
                        placeholder={"use"}
                        disableClearable
                        value={val?.use}
                        onchange={(e, value) => this.setData("use", value, i)}
                      /> */}
                      <SelectWithLabel
                        options={this?.props?.use_master ?? []}
                        label={"Use"}
                        required={true}
                        disableClearable
                        value={this.showfilter(this?.props?.use_master, val?.use)}
                        onChange={(value) => this.props.handlePersonDetailsLoop("use", value?._id ?? "", i)}
                        placeholder={"use"}
                        // onChange={(data)=>props?.onChangeState('class',data)}
                        error={val?.error?.["use"] ?? false}
                      />
                    </Col>
                    <Col className="no-padding-left">
                      {/* <Select
                        value={val?.prefix?.label ?? null}
                        onChangeValue={(e) => this.props.handlePersonDetailsLoop("prefix", e, i)}
                        getOptionLabel="label"
                        options={this?.props?.allMasters?.["prefix"]}
                        // helperText={
                        //   val?.error && val?.error["prefix"]
                        //     ? "Is required"
                        //     : ""
                        // }
                        isRequired={true}
                        error={
                          val?.error && val?.error["prefix"] ? true : false
                        }
                        label="Prefix"
                        showArrow
                        placeholder="prefix"
                        labelStyle={labelStyle}
                        inLineStyles={
                          val?.error?.prefix ? errorBorderStyle : borderStyle
                        }
                        hoverColor="#0071F2"
                      /> */}

                      {/* <Typography
                        style={{
                          fontSize: "12px",

                          Fontfamily: "pc_regular",
                          color: "#6F6F6F",
                        }}
                        variant="body1"
                      >
                        Prefix<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <SelectBox
                        list={this?.props?.allMasters?.["prefix"] ?? []}
                        placeholder={"Prefix"}
                        disableClearable
                        value={val?.prefix}
                        onchange={(e, value) =>
                          this.props.handlePersonDetailsLoop("prefix", value, i)
                        }
                      /> */}

                      <SelectWithLabel
                        options={this?.props?.prefix_master ?? []}
                        label={"Prefix"}
                        required={true}
                        disableClearable
                        value={this.showfilter(this?.props?.prefix_master, val?.prefix)}
                        onChange={(value) => this.props.handlePersonDetailsLoop("prefix", value?._id ?? "", i)}
                        placeholder={"Prefix"}
                        // onChange={(data)=>props?.onChangeState('class',data)}
                        error={val?.error?.["prefix"] ?? false}
                      />

                    </Col>
                    <Col className="no-padding-left" style={{ padding: "0" }}>
                      <TextInput
                        // helperText={
                        //   val?.error && val?.error["first_name"]
                        //     ? "Is required"
                        //     : ""
                        // }
                        value={val.first_name ? val.first_name : ""}
                        onChange={(e) =>
                          this.props.handlePersonDetailsLoop("first_name", e.target.value, i, 20)
                        }
                        isRequired={true}
                        error={
                          val?.error && val?.error["first_name"] ? true : false
                        }
                        label="First Name"
                        labelStyle={labelStyle}
                        // style={borderStyle}
                        placeholder="first name"
                        onKeyPress={function (e) {
                          var key = e.which;
                          if (
                            (key >= 65 && key <= 90) ||
                            (key >= 95 && key <= 122)
                          ) {
                            return;
                          } else {
                            e.preventDefault();
                          }
                        }}
                        hoverColor="#0071F2"
                        style={
                          val?.error?.first_name
                            ? errorBorderStyle
                            : borderStyle
                        }
                      />
                    </Col>
                    <Col className="no-padding-left">
                      <TextInput
                        value={val.middle_name ? val.middle_name : ""}
                        onChange={(e) =>
                          this.props.handlePersonDetailsLoop("middle_name", e.target.value, i, 20)
                        }
                        isRequired={true}
                        error={
                          val?.error && val?.error["middle_name"] ? true : false
                        }
                        placeholder="middle name"
                        onKeyPress={function (e) {
                          var key = e.which;
                          if (
                            (key >= 65 && key <= 90) ||
                            (key >= 95 && key <= 122)
                          ) {
                            return;
                          } else {
                            e.preventDefault();
                          }
                        }}
                        label="Middle Name"
                        labelStyle={labelStyle}
                        style={
                          val?.error?.middle_name
                            ? errorBorderStyle
                            : borderStyle
                        }
                        hoverColor="#0071F2"
                      />
                    </Col>
                    <Col className="no-padding-left" style={{ padding: "0" }}>
                      <TextInput
                        value={val.last_name ? val.last_name : ""}
                        onChange={(e) =>
                          this.props.handlePersonDetailsLoop("last_name", e.target.value, i, 20)
                        }
                        // helperText={
                        //   val?.error && val?.error["last_name"]
                        //     ? "Is required"
                        //     : ""
                        // }
                        isRequired={true}
                        onKeyPress={function (e) {
                          var key = e.which;
                          if (
                            (key >= 65 && key <= 90) ||
                            (key >= 95 && key <= 122)
                          ) {
                            return;
                          } else {
                            e.preventDefault();
                          }
                        }}
                        error={
                          val?.error && val?.error["last_name"] ? true : false
                        }
                        placeholder="last name"
                        label="Last Name"
                        labelStyle={labelStyle}
                        style={
                          val?.error?.last_name ? errorBorderStyle : borderStyle
                        }
                        hoverColor="#0071F2"
                      />
                    </Col>
                    <Col className="no-padding-left">
                      {/* <Select
                        value={val?.suffix?.label ?? null}
                        onChangeValue={(e) => this.props.handlePersonDetailsLoop("suffix", e, i)}
                        getOptionLabel="label"
                        options={this?.props?.allMasters?.["suffix"]}
                        // helperText={
                        //   val?.error && val?.error["suffix"]
                        //     ? "Is required"
                        //     : ""
                        // }
                        isRequired={true}
                        error={
                          val?.error && val?.error["suffix"] ? true : false
                        }
                        label="Suffix"
                        showArrow
                        placeholder="suffix"
                        labelStyle={labelStyle}
                        inLineStyles={
                          val?.error?.suffix ? errorBorderStyle : borderStyle
                        }
                        hoverColor="#0071F2"
                      /> */}

                      {/* <Typography
                        style={{
                          fontSize: "12px",

                          Fontfamily: "pc_regular",
                          color: "#6F6F6F",
                        }}
                        variant="body1"
                      >
                        Suffix<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <SelectBox
                        list={this?.props?.allMasters?.["suffix"] ?? []}
                        placeholder={"suffix"}
                        disableClearable
                        value={val?.suffix}
                        onchange={(e, value) =>
                          this.props.handlePersonDetailsLoop("suffix", value, i)
                        }
                      /> */}

                      <SelectWithLabel
                        options={this?.props?.surffix_master ?? []}
                        label={"Suffix"}
                        required={true}
                        disableClearable
                        value={this.showfilter(this?.props?.surffix_master, val?.suffix)}
                        onChange={(value) => this.props.handlePersonDetailsLoop("suffix", value?._id ?? "", i)}

                        placeholder={"suffix"}
                        // onChange={(data)=>props?.onChangeState('class',data)}
                        error={val?.error?.["suffix"] ?? false}
                      />
                    </Col>
                    <Col
                      style={{
                        margin: "auto",
                        padding: 0,
                      }}
                    >
                      <Div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: 18,
                        }}
                      >
                        {/* <i className="fa fa-trash-o" style={{color:'#FF4D4A',cursor:'pointer'}} aria-hidden="true"></i> */}
                        {this.props?.person_details?.personDetailList?.length > 1 && i !== 0 && (
                          <Div
                            style={{
                              width: 15,
                              height: 18,
                              cursor: "pointer",
                            }}
                          >
                            <Image
                              src="images/icons8-trash.svg"
                              alt="delete"
                              onClick={() => this.props.handleDetailsDelete(i)}
                            />
                          </Div>
                        )}
                        {this.props?.person_details?.personDetailList?.length > 1 && i === 0 && (
                          <Text
                            className="pc_medium"
                            style={{
                              color: "#F58B00",
                              // marginLeft: 15,
                              cursor: "pointer",
                              fontSize: "14px",
                            }}
                            onClick={() => this.handleLimit()}
                          >
                            {this.state.limited
                              ? "Show Less"
                              : `Show +${this.props?.person_details?.personDetailList?.length}`}{" "}
                          </Text>
                        )}
                      </Div>
                    </Col>
                  </Row>
                ))}
              <Divider
                className="p-dashed-divider "
                inLineStyles={{ margin: "5px 0px" }}
              />
              <Row 
              // className="pi-basic-details pi-actions-root" 
              className="pi-actions-root">
                <Col className="no-padding-left" style={{ padding: "0" }} md={2} lg={2} sm={6} xs={12}>
                  {/* <Select
                    isRequired={true}
                    showArrow
                    label="Gender"
                    getOptionLabel="label"
                    options={this?.props?.allMasters?.["gender"]}
                    value={details?.gender?.label ?? null}
                    onChangeValue={(e) => this.setDetails("gender", e)}
                    placeholder="select..."
                    labelStyle={labelStyle}
                    inLineStyles={
                      details?.error?.gender ? errorBorderStyle : borderStyle
                    }
                    hoverColor="#0071F2"
                    // helperText={
                    //   details?.error && details?.error["gender"]
                    //     ? "Is required"
                    //     : ""
                    // }
                    error={
                      details?.error && details?.error["gender"] ? true : false
                    }
                  /> */}

                  {/* <Typography
                    style={{
                      fontSize: "12px",

                      Fontfamily: "pc_regular",
                      color: "#6F6F6F",
                    }}
                    variant="body1"
                  >
                    Gender<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <SelectBox
                    list={this?.props?.allMasters?.["gender"] ?? []}
                    placeholder={"select..."}
                    disableClearable
                    value={details?.gender}
                    onchange={(e, value) => this.setDetails("gender", value)}
                  /> */}

                  <SelectWithLabel
                    options={this?.props?.gender_master ?? []}
                    label={"Gender"}
                    required={true}
                    disableClearable
                    value={this.showfilter(this?.props?.gender_master, this.props?.person_details?.gender)}
                    onChange={(value) => this.props.handlePersonDetails("gender", value?._id ?? "")}
                    placeholder={"select..."}
                    // onChange={(data)=>props?.onChangeState('class',data)}
                    error={this.props?.person_details?.error?.["gender"] ?? false}
                  />
                </Col>
                <Col className="no-padding-left" md={3} lg={3} sm={6} xs={12}>
                  <Typography
                    style={{
                      fontSize: "12px",
                      Fontfamily: "pc_regular",
                      color: "#6F6F6F",
                      paddingBottom: 8
                    }}
                    variant="body1"
                  >
                    Date of Birth <span style={{ color: "red" }}>*</span>
                  </Typography>
                  {/* <TextInput
                    value={this.props?.person_details?.date_of_birth ? new Date(this.props?.person_details?.date_of_birth) : null}
                    onChange={(e) =>
                      this.props?.handlePersonDetails("date_of_birth", e.target.value)
                    }
                    error={this.props?.person_details?.error?.["date_of_birth"] ?? false}

                      label="Birth date"
                      type="date"
                      labelStyle={labelStyle}
                      style={borderStyle}
                      hoverColor="#0071F2"
                  /> */}
                  {/* {
                    JSON.stringify(moment(this.props?.person_details?.date_of_birth, "DD/MM/YYYY")) 
                  } */}
                  {/* <DateTimePicker
                    required={true}
                    label={""}
                    placeholder={"dd/mm/yyyy"}
                    dateFormat={"dd/MM/yyyy"}
                    onChange={(value) => {
                      this.props?.handlePersonDetails("date_of_birth", moment(value).format('DD/MM/YYYY'))
                    }}
                    value={this.props?.person_details?.date_of_birth ? moment(this.props?.person_details?.date_of_birth, "DD/MM/YYYY") : null}

                  // error={details?.error?.["dob"] ?? false}
                  // maxDate={new Date(moment(new Date(), "DD/MMM/YYYY"))}
                  // minDate={this.props?.person_details?.date_of_birth ? moment(this.props?.person_details?.date_of_birth).diff(moment(new Date()), 'days') >= 0 ? new Date() : moment(this.props?.person_details?.date_of_birth) : new Date()}
                  maxDate={
                    new Date()
                  }
                  /> */}
                  <CustomInputDatePicker
                    disabled={false}
                    placeholderText="dd / mm / yyyy"
                    maxDate={new Date()}
                    selectedDate={
                      this.props?.person_details?.date_of_birth ?
                        new Date(this.props?.person_details?.date_of_birth) : null
                    }
                    handleChange={(value) =>
                      value ? 
                      this.props?.handlePersonDetails(
                        "date_of_birth",
                        moment(value).format("DD/MM/YYYY")
                        // value
                      ) : {}
                    }
                    inputField={
                      <TextField
                        placeholder="dd / mm / yyyy"
                        fullWidth
                        variant="outlined"
                        required={true}
                        value={
                          this.props?.person_details?.date_of_birth
                            ? moment(new Date(this.props?.person_details?.date_of_birth)).format("DD / MM / YYYY")
                            : null
                        }
                        inputProps={{
                          style: {
                            padding: "10.5px 14px",
                            fontFamily: "poppin",
                            fontSize: "12px",
                            borderRadius: 8,
                            borderColor: "#e0e0e0",
                          },
                        }}
                      />
                    }
                  />

                  {/* <TextInput 
                    value={person_details.dob ? person_details.dob : ""}
                    error={
                      person_details?.error && person_details?.error["dob"] ? true : false
                    }
                    max={moment(new Date()).format("YYYY-MM-DD")}
                    onChange={(e) =>
                      this.handlePersonDetails("dob", e.target.value, "age")
                    }
                    isRequired={true}
                    label="Date of Birth"
                    type="date"
                    labelStyle={labelStyle}
                    style={person_details?.error?.dob ? errorBorderStyle : borderStyle}
                    hoverColor="#0071F2"
                  /> */}
                </Col>

                <Col className="no-padding-left" style={{ padding: "0" }} md={3} lg={3} sm={6} xs={12}>
                  {/* <Select
                    // options={optiondata}
                    getOptionLabel="label"
                    options={this?.props?.allMasters?.["marital_status"]}
                    label="Marital status"
                    value={person_details?.marital_status?.label ?? null}
                    onChangeValue={(e) => this.handlePersonDetails("marital_status", e)}
                    showArrow
                    placeholder="select..."
                    labelStyle={labelStyle}
                    inLineStyles={borderStyle}
                    hoverColor="#0071F2"
                  /> */}

                  {/* <Typography
                    style={{
                      fontSize: "12px",

                      Fontfamily: "pc_regular",
                      color: "#6F6F6F",
                    }}
                    variant="body1"
                  >
                    Marital status <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <SelectBox
                    list={this?.props?.allMasters?.["marital_status"] ?? []}
                    placeholder={"select..."}
                    disableClearable
                    value={person_details?.marital_status}
                    onchange={(e, value) =>
                      this.handlePersonDetails("marital_status", value)
                    }
                  /> */}


                  <SelectWithLabel
                    label={"Managing Entity Type"}
                    options={this?.props?.entity_type_master ?? []}
                    required={true}
                    disableClearable
                    value={this.showfilter(this?.props?.entity_type_master, this.props?.person_details?.managing_entity_type)}
                    onChange={(value) => this.props.handlePersonDetails("managing_entity_type", value?._id ?? "")}
                    placeholder={"select..."}
                    // onChange={(data)=>props?.onChangeState('class',data)}
                    error={this.props?.person_details?.error?.["managing_entity_type"] ?? false}
                  />

                </Col>

                <Col className="no-padding-left" md={4} lg={4} sm={6} xs={12}>
                  {/* <Typography
                    style={{
                      fontSize: "12px",

                      Fontfamily: "pc_regular",
                      color: "#6F6F6F",
                    }}
                    variant="body1"
                  >
                    Nationality <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <SelectBox
                    list={this?.props?.allMasters?.["nationality"] ?? []}
                    placeholder={"select..."}
                    disableClearable
                    value={person_details?.nationality}
                    onchange={(e, value) =>
                      this.handlePersonDetails("nationality", value)
                    }
                  /> */}

                  <SelectWithLabel
                    label={"Managing Entity Name"}
                    options={this?.props?.entity_name_master ?? []}
                    required={true}
                    disableClearable
                    value={this.showfilter(this?.props?.entity_name_master, this.props?.person_details?.managing_entity_name)}
                    onChange={(value) => this.props.handlePersonDetails("managing_entity_name", value?._id ?? "")}


                    placeholder={"select..."}
                    error={this.props?.person_details?.error?.["managing_entity_name"] ?? false}
                  />

                </Col>
                {/* <Col className="no-padding-left" style={{ padding: "0" }}>
                      <TextInput
                        value={this.props?.person_details?.email_id ? this.props?.person_details?.email_id : ""}
                        onChange={(e) =>
                          this.props.handlePersonDetails("email_id", e.target.value)
                        }
                        // helperText={
                        //   val?.error && val?.error["email_id"]
                        //     ? "Is required"
                        //     : ""
                        // }
                        isRequired={true}
                        // onKeyPress={function (e) {
                        //   var key = e.which;
                        //   if (
                        //     (key >= 65 && key <= 90) ||
                        //     (key >= 95 && key <= 122)
                        //   ) {
                        //     return;
                        //   } else {
                        //     e.preventDefault();
                        //   }
                        // }}
                        error={
                          this.props?.person_details?.error && this.props?.person_details?.error["email_id"] ? true : false
                        }
                        placeholder="Email id"
                        label="Email  Id"
                        labelStyle={labelStyle}
                        style={
                          this.props?.person_details?.error?.email_id ? errorBorderStyle : borderStyle
                        }
                        hoverColor="#0071F2"
                      />
                    </Col> */}
                {/* <Col className="no-padding-left" style={{ padding: "0" }}>
                  <H6 className="default-size pc_regular">External</H6>
                  <Checkbox
                    checked={details?.external}
                    onChange={(e) =>
                      this.setDetails("external", !details?.external)
                    }
                    name=""
                    color="#0071F2"
                  />
                </Col> */}
                {/* <Col className="no-padding-left" style={{ padding: "0" }}>
                <Typography
                    style={{
                      fontSize: "12px",
                      Fontfamily: "pc_regular",
                      color: "#6F6F6F",
                      paddingBottom: 8
                    }}
                    variant="body1"
                  >
                    Email <span style={{ color: "red" }}>*</span>
                  </Typography>
                <TextInput
                  value={details?.email ? details?.email : ""}
                  onChange={(e) =>
                    // this.setData("email", e.target.value)
                    this.setDetails("email", e.target.value)
                  }
                  isRequired={true}
                  error={
                    details?.error && details?.error["email"] ? true : false
                  }
                  placeholder="email"
                  // label="email"
                  labelStyle={labelStyle}
                  style={
                    details?.error?.middle_name
                      ? errorBorderStyle
                      : borderStyle
                  }
                  hoverColor="#0071F2"
                />
                </Col> */}
                {/* <Col className="no-padding-left" >
                  <H6 className="default-size pc_regular" style={{paddingBottom: 8}} >Status</H6>
                  <FormControlLabel
                    control={
                      <this.IOSSwitch
                        checked={details?.status}
                        onChange={(e) =>
                          this.setDetails("status", !details?.status)
                        }
                      />
                    }
                  />
                </Col> */}
              </Row>
            </Paper>
          </Col>
        </Row>
      </Div>
    );
  }
}

export default withAllContexts(PersonNames);
